import useIsCorpView from "./useIsCorpView"
import { useAppSelector } from "../redux/store"
import { selectCustomer } from "../redux/customer"
import { selectChildCustomer } from "../redux/childCustomer"

const useCustomer = () => {
  const isCorpView = useIsCorpView()

  const customer = isCorpView
    ? useAppSelector(selectChildCustomer)
    : useAppSelector(selectCustomer)

  return customer
}

export default useCustomer
